import Error from "@/Components/Error";
import Spinner from "@/Components/Spinner/Spinner";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import { useSetPosOrderMenuValues } from "@/shared/atoms/usePosOrderMenuValuesAtom";
import { useSetPosOrderUser } from "@/shared/atoms/usePosOrderUser";
import useBranchId from "@/shared/hooks/useBranchId";
import useCategoryQueryHook from "@/shared/hooks/useCategoryQueryHook";
import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import useIsOrderEditingHook from "@/shared/hooks/useIsOrderEditingHook";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";
import useStandardMenuTargetHook from "@/shared/hooks/useStandardMenuTargetHook";
import { CategoryCardPositionEnum, DeliveryMethods } from "@/shared/utils/enum";
import { useEffect } from "react";
import CategoryCardLeft from "./CategoryCardLeft";
import CategoryCardStandard from "./CategoryCardStandard";
import CategoryCardTop from "./CategoryCardTop";
import PosMenuTop from "./PosMenuTop";
import PosMenuBottom from "./PosMenuBottom";
import PosTables from "@/Pages/Auth/Bestellingen/PosOrder/PosTables";
import usePosOrderTable from "@/shared/atoms/usePosOrderTable";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import useWaiterView from "@/shared/atoms/useWaiterView";

const PosMenu = ({ children }) => {
  const isMobile = useIsMobileHook();
  const branch = useBranchId();
  const { settings } = usePosSettingsHook();
  const [table] = usePosOrderTable();
  const { isOrderEditing } = useIsOrderEditingHook();
  const [deliveryMethod] = usePosOrderDeliveryMethod();
  const isWaiter = useIsWaiter();
  const [waiterView] = useWaiterView();

  const { standardMenuTarget, hasStandardMenuTarget } =
    useStandardMenuTargetHook();
  const { refetch, isError, isSuccess, isPending } = useCategoryQueryHook();
  const setPosOrderMenuValues = useSetPosOrderMenuValues();
  const setPosOrderUser = useSetPosOrderUser();

  useEffect(() => {
    hasStandardMenuTarget && refetch();
  }, [standardMenuTarget]);

  useEffect(() => {
    !hasStandardMenuTarget && refetch();
    setPosOrderMenuValues((draft) => {
      draft.selectedCat = null;
      draft.selectedTab = 0;
    });
    deliveryMethod === DeliveryMethods.POS_ORDER &&
      !isOrderEditing &&
      setPosOrderUser(null);
  }, [branch, deliveryMethod, standardMenuTarget]);

  const cardPosition = settings.category_card_position;

  if (isWaiter) {
    if (waiterView === "tables") {
      return <PosTables />;
    }
  } else if (deliveryMethod === DeliveryMethods.DINE_IN && table === null) {
    return <PosTables />;
  }

  return (
    <>
      <PosMenuTop />
      {isPending && <Spinner />}
      {isError && <Error refetch={refetch} />}
      {isSuccess && (
        <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
          <div
            data-tour="pos-order.menu"
            className="min-h-0 flex-1 overflow-hidden"
          >
            {!isMobile && cardPosition === CategoryCardPositionEnum.LEFT ? (
              <CategoryCardLeft settings={settings} />
            ) : !isMobile && cardPosition === CategoryCardPositionEnum.TOP ? (
              <CategoryCardTop settings={settings} />
            ) : (
              <CategoryCardStandard settings={settings} />
            )}
          </div>
          {!isWaiter && (
            <div data-tour="pos-order.actions" className="shrink-0">
              <PosMenuBottom settings={settings} />
            </div>
          )}
        </div>
      )}
      {children}
    </>
  );
};

export default PosMenu;
